"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { viuGoTrendClass } from "./ViuGoTrendUtils";

export default function ViuGoThreeColSection({ title, items, width = "ods-50" }) {
    return (
        <div
            className={`viugo-ods-detail-item ${width} flex min-w-0 flex-col !bg-transparent !p-0`}
        >
            <div className="relative flex w-full flex-row gap-[10px]">
                <div className="kbv-text-black-odds-indigo-slate relative z-[1] cursor-default select-none rounded-t-[4px] bg-[var(--theme-live-chip-bg)] px-2 py-1 text-[12px] font-bold leading-tight">
                    {title}
                </div>
            </div>
            <div className="kbv-bg-odt-item-indigo-slate -mt-px rounded-b-[4px] rounded-tr-[4px] p-2.5">
                <div className="viugo-odstb-odds-list">
                    {items.map((item, i) => (
                        <div key={i}>
                            <div className="viugo-title-odds">{item.label}</div>
                            <div className={`odds ods-100 ods-white max-md:!text-[9px] ${viuGoTrendClass(item.trend)}`}>
                                {displayValue(item.value)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
